import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { TickValueComponent } from '../../tick-value/tick-value.component';
import { ColdCompressAction } from 'src/app/types/sheet-action-aggregate-graph.types';

@Component({
    selector: 'app-cold-compress-slot',
    templateUrl: './cold-compress-slot.component.html',
    styleUrl: './cold-compress-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ColdCompressSlotComponent implements SheetSlotComponentBase {

	@Input() action!: ColdCompressAction;
	value = null;

	constructor() {
	}
}